/*---- File - twoPartyChitForm.jsx 

   container for the form wizard pages

   -- gets the two party chit id from the modal if exists
      - if no params id - then the modal was opened from the new Chit icon
      - if params id yes - the modal was opened from the edit icon

   Contains children: 
       twoPartyChitForm pages 
   parent: modal 
*/


import React, {useState, useEffect}  from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate, useParams } from 'react-router-dom'
import { chitBlueDull, chitBurgandy, lightGrey, mediumLightGrey } from '../styles/colors'

import { isWordInArray } from '../app/helpers/commonHelpers'

import {
  closeLogSectionForm, 
  closeNewLogForm, 
  selectStatus, 
  updateFormPageView,
  initializeTwoPartyViewData

} from '../app/redux/statusRedux/statusSlice'

import { selectPeople } from '../app/redux/peopleRedux/peopleSlice'
import { selectGroups } from '../app/redux/groupRedux/groupSlice'
import { selectAllTwoPartyChits } from '../app/redux/twoPartyChitRedux/twoPartyChitsSlice'
// --- page imports
import TwoPartyChitFormWho from './TwoPartyChitForm_who'
import TwoPartyChitFormWhen from './TwoPartyChitForm_when'
import TwoPartyChitFormChit from './TwoPartyChitForm_chit'
import TwoPartyChitFormDetails from './TwoPartyChitForm_details'
import TwoPartyChitFormPreview from './TwoPartyChitForm_preview'
import TwoPartyChitFormCompleted from './SharedChitFormMessage'


// ---mui imports 

import { styled, createTheme} from '@mui/material/styles'
import {withStyles} from '@mui/styles'



const theme = createTheme(); // allows use of mui theme in styled component


// ==============================================================

export default function TwoPartyChitForm(props) {
 
  const dispatch = useDispatch()
// console.log('[ TwoPartyChitForm in chitgit ] props ', props);
  // --  get id from modal if exists
  // if no id - new form :   if id yes - edit
  
  let passedId = props.modalParams.id

  console.log('[ TWO PARTY CHIT FORM INITIAL DATA ] passedId ', passedId);
 
  const status = useSelector(selectStatus)
  let formPage = status.view.forms.twoPartyChitForm.formPage
  let completedPagesArray = status.view.forms.twoPartyChitForm.completedPagesArray
  const allPeople = useSelector(selectPeople)
  const allGroups = useSelector(selectGroups)
  let allTwoPartyChits = useSelector(selectAllTwoPartyChits)

  let breadCrumbsArray = ['who', 'when', 'details', 'chit' , 'preview']


// --- 

let chitToBeEdited = allTwoPartyChits.find(chit => chit.id === passedId)
  console.log('[ TWO PARTY CHIT FORM INITIAL DATA ] chitToBeEdited ', chitToBeEdited);

let  id, chitType, chitBurden, chitValue, chitDate, otherPartyCollection, otherPartyId, deedPerformedBy, workRelated, description, keyWordArray, sharedId, startingFormPage,  startingBreadCrumbsArray

  /*
    if there is no chit id passed from the modal - form is for new chit,
        and chitToBeEdited will be undefined
        set up status.view.form.twoParty chit with empty values
    
    if there is a chit id passed from modal - chit is to be edited
        set up status.view.form.twoParty chit with DEFAULT  values 
        from chitToBeEdited
  */
  
  chitToBeEdited ? id = passedId: id = ''
  chitToBeEdited ? chitType = chitToBeEdited.chitType: chitType = ''

  chitToBeEdited ? chitBurden = chitToBeEdited.chitBurden: chitBurden = 0
  chitToBeEdited ? chitValue = chitToBeEdited.chitValue: chitValue = 0
  chitToBeEdited ? chitDate = chitToBeEdited.chitDate: chitDate = ''
  chitToBeEdited ? otherPartyCollection = chitToBeEdited.otherPartyCollection: otherPartyCollection = ''
  chitToBeEdited ? otherPartyId = chitToBeEdited.otherPartyId: otherPartyId = ''
  
  // chitToBeEdited ? deedPerformedBy = chitToBeEdited.deedPerformedBy: deedPerformedBy = ''

  if(chitToBeEdited){
    if(chitToBeEdited.deedPerformedBy === chitToBeEdited.otherPartyId){
      deedPerformedBy = 'otherParty'
    }else{ deedPerformedBy = 'me'}
  }

  if(!chitToBeEdited) {deedPerformedBy = ''}



  chitToBeEdited ? workRelated = chitToBeEdited.workRelated: workRelated = ''
  chitToBeEdited ? description = chitToBeEdited.description: description = ''

  chitToBeEdited ? sharedId = chitToBeEdited.sharedId: sharedId = ''
  chitToBeEdited ? startingFormPage = 'preview': startingFormPage = 'who'

  chitToBeEdited ? startingBreadCrumbsArray = breadCrumbsArray: startingBreadCrumbsArray = []
  
  let personNameDisplayed,groupNameDisplayed,  personObject, groupObject
  
  if(otherPartyCollection === 'people'){
    personObject = allPeople.find(person => person.id === otherPartyId)
  
    personNameDisplayed = personObject.name
  }
  
  
  if(otherPartyCollection === 'groups'){
  groupObject = allGroups.find(group => group.id === otherPartyId)
  groupNameDisplayed = groupObject.name
  }
  
  
  let formOtherPartyCollection
  if(otherPartyCollection === 'people'){formOtherPartyCollection = 'person'}
  if(otherPartyCollection === 'groups'){formOtherPartyCollection = 'group'}


console.log('[ TwoPartyForm ] startingFormPage  outside useEffect ', startingFormPage  );
 
console.log('[ TwoPartyForm ] startingBreadCrumbsArray  outside useEffect ', startingBreadCrumbsArray  );


 useEffect(()=> {


  console.log('[ TwoPartyForm ] startingFormPage  INSIDE useEffect ', startingFormPage  );
 
  console.log('[ TwoPartyForm ] startingBreadCrumbsArray  INSIDE useEffect ', startingBreadCrumbsArray  );


    // console.log('[ twoPartyChitForm ] passedId ', passedId);
    let initialData =  {
      id: id,
      formPage: startingFormPage,
      completedPagesArray: startingBreadCrumbsArray,
      chitType: chitType,
      chitValue: chitValue,
      chitBurden: chitBurden,
      chitDate: chitDate,
      otherPartyCollection: formOtherPartyCollection,
      otherPartyId: otherPartyId,
      person: personNameDisplayed,
      group: groupNameDisplayed,
      deedPerformedBy: deedPerformedBy,
      workRelated: workRelated,
      description: description,
 
      sharedId: sharedId, 
      
    }
  
    dispatch(initializeTwoPartyViewData({pageType: 'twoPartyChitForm', data: initialData}))
  

  
 }, [])


 /* --- BreadCrumbs logic --------------------------
      if page active - red
      if page !active but completed - blue
      if page !active and Not completed - grey

 */


  

  let breadCrumbPage = breadCrumbsArray.map((breadCrumb, index) => {

    let pageCompleted = isWordInArray(breadCrumb, completedPagesArray)

    // console.log('[ TWO PARTY CHIT FORM ] yes no ', breadCrumb, ' ? ',  pageCompleted);


    if (breadCrumb === formPage) {
      return (
        <BreadCrumbDisabled key={breadCrumb} id={breadCrumb}> {breadCrumb} </BreadCrumbDisabled>
      )
    }else if(breadCrumb !== formPage && completedPagesArray.length < 4){
      return(
      <BreadCrumbInactive  key={breadCrumb} > {breadCrumb} </BreadCrumbInactive>
      )
    } else {
      return (
        <BreadCrumb 
        key={breadCrumb} 
        id={breadCrumb} 
        // onClick = {(evt)=>changePage(evt)}
        
        > {breadCrumb} </BreadCrumb>

      )
    }
  }) // end if else


  function changePage(evt){
    let newPage = evt.currentTarget.id
    console.log('[ twoPartyChitForm - change page function ] evt.currentTarget.id ', evt.currentTarget.id);

    dispatch(updateFormPageView({pageType: 'twoPartyChitForm', page: newPage}))
  }
  // === Main Return =====================================

  return (
    <Wrapper>
      <BreadCrumbsWrapper>
        {breadCrumbPage}
      </BreadCrumbsWrapper>

      <PageWrapper>
  
        {formPage === 'who' &&
          <TwoPartyChitFormWho id = {passedId} />
        }  
        { formPage === 'when' &&
          <TwoPartyChitFormWhen />
        }  
        {formPage === 'details' &&
          <TwoPartyChitFormDetails />
        }  
        {formPage === 'chit' &&
          <TwoPartyChitFormChit />
        }  

        {formPage === 'preview' &&
          <TwoPartyChitFormPreview />
        }  



        {formPage === 'completed' &&
          <TwoPartyChitFormCompleted />
        }  


      </PageWrapper>
      


      
    </Wrapper>
  )
} // --- end breadCrumbPage


// ==== Styles ===========================================
const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  // zIndex: '95',
  
  width: 'calc(100%-12px)',
  height: '100%',
  overflow: 'auto',
  padding: '0 0 3px 4px',
// backgroundColor: 'red',

borderRadius: '5px',
  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

const PageWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  // zIndex: '95',
  backgroundColor: 'yellow',
  width: '100%',
  marginTop: '1rem',

  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

const BreadCrumbsWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '.8rem',
  width: '100%',

  padding: '0 0 3px 16px',

  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

const BreadCrumb = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: '1.5rem',
  color: mediumLightGrey,
   

  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

const BreadCrumbDisabled = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: chitBurgandy,
  marginRight: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

const BreadCrumbInactive = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: mediumLightGrey,
  marginRight: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },

})

